import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener
} from '@angular/material/tree';
export class AttributeClass {
  class: string;
  parentId: number;
  childClass: string;
  thisClass: string;
}
/**
 * Node for feature item
 */
export class FeatureItemNode {
  id: number;
  Id: any;
  nodeId: any;
  nodes: FeatureItemNode[];
  title: string;
  nodeType: string;
  subType: string;
  processRId: any;
  processId: any;
  meterId: any;
  meterRId: any;
  loadId: any;
  loadRId: any;
  kwRating: any;
  selected: boolean;
  attributes: AttributeClass;
  hasAttachment: boolean;
  RId: number;
  index: number;
  level: number;
  parameters: FeatureItemNode[];
}
/** Flat feature item node with expandable and level information */
export class FeatureItemFlatNode {
  id: number;
  Id: any;
  nodeId: any;
  title: string;
  level: number;
  expandable: boolean;
  attributes: AttributeClass;
  nodes: FeatureItemNode[];
  nodeType: string;
  subType: string;
  processId: any;
  processRId: any;
  meterId: any;
  meterRId: any;
  loadId: any;
  loadRId: any;
  kwRating: any;
  hasAttachment: boolean;
  RId: number;
  index: number;
  parameters: FeatureItemNode[];
}
export class Hierarchy {
  public checklistSelection = new SelectionModel<FeatureItemFlatNode>(
    false /* mul */
  );
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  public flatNodeMap = new Map<FeatureItemFlatNode, FeatureItemNode>();
  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  public nestedNodeMap = new Map<FeatureItemNode, FeatureItemFlatNode>();
  /** A selected parent node to be inserted */
  public selectedParent: FeatureItemFlatNode | null = null;
  public activeNode: any;
  public treeControl: FlatTreeControl<FeatureItemFlatNode>;
  public treeFlattener: MatTreeFlattener<FeatureItemNode, FeatureItemFlatNode>;
  public dataSource: MatTreeFlatDataSource<
    FeatureItemNode,
    FeatureItemFlatNode
  >;
  // organizationDataSource = new MatTableDataSource<OrganizationModel>();
  public selectedNode: FeatureItemFlatNode;
  constructor() {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<FeatureItemFlatNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
  }
  /* Begin Function on Tree*/
  public getLevel = (node: FeatureItemFlatNode) => node.level;

  public isExpandable = (node: FeatureItemFlatNode) => node.expandable;

  public getChildren = (node: FeatureItemNode): FeatureItemNode[] => node.nodes;

  public hasChild = (_: number, _nodeData: FeatureItemFlatNode) =>
    _nodeData.nodes !== undefined && _nodeData.nodes.length > 0;

  public hasNoContent = (_: number, _nodeData: FeatureItemFlatNode) =>
    _nodeData.title === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  public transformer = (node: FeatureItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.title === node.title
        ? existingNode
        : new FeatureItemFlatNode();
    flatNode.title = node.title;
    flatNode.level = level;
    flatNode.id = node.id;
    flatNode.Id = node.Id;
    flatNode.nodeId = node.nodeId;
    flatNode.nodes = node.nodes;
    flatNode.nodeType = node.nodeType;
    flatNode.subType = node.subType;
    flatNode.processId = node.processId;
    flatNode.processRId = node.processRId;
    flatNode.meterId = node.meterId;
    flatNode.meterRId = node.meterRId;
    flatNode.loadId = node.loadId;
    flatNode.loadRId = node.loadRId;
    flatNode.kwRating = node.kwRating;
    flatNode.expandable = !!node.nodes;
    flatNode.hasAttachment = node.hasAttachment;
    flatNode.RId = node.RId;
    flatNode.index = node.index;
    flatNode.parameters = node.parameters;
    if (node.attributes) {
      const attribute = new AttributeClass();
      attribute.class = node.attributes.class;
      attribute.parentId = node.attributes.parentId;
      attribute.childClass = node.attributes.childClass;
      attribute.thisClass = node.attributes.thisClass;
      flatNode.attributes = attribute;
    }
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    if (node.selected) {
      this.checklistSelection.select(flatNode);
    }
    return flatNode;
  };
}
